import { styled } from "@mui/material/styles";
import LoadingSpinner from "components/atomics/LoadingSpinner";
import { toastStateAtom } from "components/atomics/Toast/toastState";
import L from "leaflet";
import getTestIDs from "lib/utils/getTestIDs";
import { StorageAreaCreateForm } from "raft/StorageAreaForm";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import translations from "translations";
import { newStorageAreaIdAtom } from "../../recoilBox";

export const testIDs = getTestIDs();

const CreateStorageAreaSC = styled("div")({
  height: "80vh",
});

const AddGeofence: React.FC<{}> = () => {
  const history = useHistory();
  const setToastObject = useSetRecoilState(toastStateAtom);
  const [state, setstate] = useState(false);
  const setNewStorageAreaId = useSetRecoilState(newStorageAreaIdAtom);
  const close = () => {
    history.push("/fleetInventory");
  };

  const afterSave = (data: { id: string }) => {
    try {
      setNewStorageAreaId(data.id);
      setToastObject({
        open: true,
        message: translations.pages.fleetInventory.toastMessageCreate.success,
        severity: "success",
      });
      close();
    } catch (error) {
      setToastObject({
        open: true,
        message: translations.pages.fleetInventory.toastMessageCreate.error,
        severity: "error",
      });
      close();
    }
  };
  return (
    <CreateStorageAreaSC>
      <LoadingSpinner hideChildrenOnLoad loading={state}>
        <StorageAreaCreateForm
          onCancel={close}
          afterCreate={afterSave}
          beforeRemoteMuatation={(p) => {
            setstate(true);
            return {
              ...p.data,
            };
          }}
          //@ts-ignore
          onUpdateDataMiddleWare={(p) => {
            console.log("onUpdateDataMiddleWare", p);
            if (!p?.data?.storageAreaName?.length) {
              return {
                ...p.data,
                disableStep: 1,
                noPolygon: 1,
              };
            }

            if (!p.data.geofence?.coordinates) {
              return {
                ...p.data,
                disableStep: 1,
                noPolygonWarning: translations.pages.fleetInventory.noPolygonWarning,
                noPolygon: 0,
              };
            }

            //@ts-ignore
            if (!!p.data.formHasErrors && p.data.submit) {
              return {
                ...p.data,
                //@ts-ignore
                submit: !p.data.formHasErrors,
              };
            }
            if (p.data.geofence) {
              const minAllowedPolygonSize = 2500; // min 50x50m = 2,500 m²
              const maxAllowedPolygonSize = 500000000; // max 500 km² = 500,000,000 m²
              const polygon = L.polygon(p.data.geofence?.coordinates);
              const polygonSize = L.GeometryUtil.geodesicArea(polygon.getLatLngs()[0] as L.LatLngLiteral[]);

              if (polygonSize < minAllowedPolygonSize) {
                setToastObject({
                  open: true,
                  message: translations.pages.fleetInventory.smallGeofenceWarning,
                  severity: "error",
                });
                return {
                  ...p.data,
                  disableStep: 1,
                  noPolygonWarning: translations.pages.fleetInventory.noPolygonWarning,
                  noPolygon: 0,
                };
              }

              if (polygonSize > maxAllowedPolygonSize) {
                setToastObject({
                  open: true,
                  message: translations.pages.fleetInventory.largeGeofenceWarning,
                  severity: "error",
                });
                return {
                  ...p.data,
                  disableStep: 1,
                  noPolygonWarning: translations.pages.fleetInventory.noPolygonWarning,
                  noPolygon: 0,
                };
              }
            }

            setToastObject(undefined);
            return {
              ...p.data,
              disableStep: 0,
              noPolygonWarning: "",
              noPolygon: 1,
              formHasErrors:
                !p.data.storageAreaTypeId || !p.data.storageAreaName || !p.data.geofence?.coordinates ? 1 : 0,
            };
          }}
        />
      </LoadingSpinner>
    </CreateStorageAreaSC>
  );
};

export default AddGeofence;
